<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" class="scaling-svg">
      <g transform="translate(-440 -448.641)">
        <g transform="translate(440 448.64)">
          <circle cx="0.358" cy="0.358" r="0.358" transform="translate(2.405 0.693)" />
          <path
            d="M112.162,108.641a.358.358,0,1,0-.506,0A.358.358,0,0,0,112.162,108.641Z"
            transform="translate(-109.153 -105.707)"
          />
          <path
            d="M378.8,352.781a.358.358,0,1,0,.455.222A.358.358,0,0,0,378.8,352.781Z"
            transform="translate(-370.425 -345.177)"
          />
          <path
            d="M445.737,377.044a.358.358,0,1,0,.455.222A.358.358,0,0,0,445.737,377.044Z"
            transform="translate(-435.919 -368.918)"
          />
          <path
            d="M78.216,220.669a.276.276,0,0,0-.182-.182l-.706-.22a.037.037,0,0,0-.038.009L73.769,223.8a.039.039,0,0,0,0,.054h0l1.094,1.094.013.014,3.549-3.549a.037.037,0,0,0,.009-.038Z"
            transform="translate(-72.172 -215.53)"
          />
          <path
            d="M211.519,4.593,210.329,3a.358.358,0,0,1-.052-.329l.639-1.883a.125.125,0,0,0-.159-.159l-1.883.639a.358.358,0,0,1-.329-.052L206.951.026a.125.125,0,0,0-.2.1l.025,1.988a.358.358,0,0,1-.151.3L205,3.561a.125.125,0,0,0,.035.221l1.9.59a.358.358,0,0,1,.236.236l.59,1.9a.125.125,0,0,0,.221.035l1.148-1.624a.358.358,0,0,1,.292-.151h0l1.988.025A.125.125,0,0,0,211.519,4.593Z"
            transform="translate(-200.544 0)"
          />
          <path
            d="M1.09,410.13h0a.038.038,0,0,0-.054,0l-.8.8a.8.8,0,1,0,1.136,1.136l.829-.829-.014-.013Z"
            transform="translate(0 -401.3)"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class WandIcon extends Vue {}
</script>

<style></style>
